__turbopack_context__.v({
  "blok-big-title": "Breadcrumbs-module___5TZNG__blok-big-title",
  "blok-subtitle": "Breadcrumbs-module___5TZNG__blok-subtitle",
  "blok-title": "Breadcrumbs-module___5TZNG__blok-title",
  "breadcrumbs": "Breadcrumbs-module___5TZNG__breadcrumbs",
  "crumb__inactive": "Breadcrumbs-module___5TZNG__crumb__inactive",
});
